import React from 'react';
import { Link } from 'react-router-dom';
import pageNotFound from '../assets/undraw_nao_encontrado.svg';
import './NotFoundPage.css';


const NotFoundPage = () => {
  return (
    <div className="nf-raiz">
      <h1>404 - Página Não Encontrada</h1>
      <p>Ops! A página que você está procurando não existe.</p>
      {/* Exemplo de imagem para um erro 404 */}
      <img
        className="nf-img"
        src={pageNotFound}
        alt="Página não encontrada"
      />
      <p>
        <Link className="nf-voltar" to="/monitoramento">Voltar para a página inicial</Link>
      </p>
    </div>
  );
};

export default NotFoundPage;
